import { isLowConfidence } from '@dma/shared';
import { fmt } from '../format.ts';
import { LowNBadge } from '../ui.tsx';
import { QuadrantChip } from '../ui.tsx';
import type { SummaryRow } from '../types.ts';

// View 3 — the accessible equivalent of the radar. Rows already arrive sorted
// worst-first (mean ascending); we render them in order.
export function SummaryTableView({ data }: { data: SummaryRow[] }) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse text-sm">
        <caption className="sr-only">
          Dimension summary: mean, median, standard deviation, quadrant and respondent count, sorted worst-first.
        </caption>
        <thead>
          <tr className="border-b border-black/10 text-left text-xs uppercase tracking-wide text-ink-soft">
            <th scope="col" className="py-2 pr-4 font-semibold">Dimension</th>
            <th scope="col" className="py-2 pr-4 text-right font-semibold">Mean</th>
            <th scope="col" className="py-2 pr-4 text-right font-semibold">Median</th>
            <th scope="col" className="py-2 pr-4 text-right font-semibold">SD</th>
            <th scope="col" className="py-2 pr-4 font-semibold">Quadrant</th>
            <th scope="col" className="py-2 text-right font-semibold">n</th>
          </tr>
        </thead>
        <tbody>
          {data.map((d) => (
            <tr key={d.slug} className="border-b border-black/5 last:border-0">
              <th scope="row" className="py-2.5 pr-4 text-left font-medium text-ink">{d.name}</th>
              <td className="py-2.5 pr-4 text-right tabular-nums text-ink">{fmt(d.mean)}</td>
              <td className="py-2.5 pr-4 text-right tabular-nums text-ink-soft">{fmt(d.median)}</td>
              <td className="py-2.5 pr-4 text-right tabular-nums text-ink-soft">{fmt(d.sd)}</td>
              <td className="py-2.5 pr-4"><QuadrantChip quadrant={d.quadrant} /></td>
              <td className="py-2.5 text-right tabular-nums text-ink-soft">
                <span className="inline-flex items-center justify-end gap-1.5">
                  {d.n}
                  {isLowConfidence(d.n) && <LowNBadge />}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
